import { useState, useEffect } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../ui/table';
import { toast } from 'sonner';
import { api } from '../../utils/api';
import { Trash2 } from 'lucide-react';

const StaffTrustedDevices = () => {
  const [devices, setDevices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadDevices();
  }, []);

  const loadDevices = async () => {
    setLoading(true);
    try {
      const response = await api.getStaffTrustedDevices();
      setDevices(response.devices);
    } catch (error) {
      toast.error('Failed to load devices');
    } finally {
      setLoading(false);
    }
  };

  const handleRemove = async (deviceId) => {
    if (!window.confirm('Remove this trusted device? You will need OTP on next login from this device.')) return;

    try {
      await api.removeStaffTrustedDevice(deviceId);
      toast.success('Device removed');
      loadDevices();
    } catch (error) {
      toast.error(error.message);
    }
  };

  const formatDate = (isoString) => {
    const date = new Date(isoString);
    return date.toLocaleString();
  };

  return (
    <div className="space-y-6 animate-fade-in">
      <div>
        <h2 className="text-2xl font-bold text-slate-900" data-testid="trusted-devices-title">Trusted Devices</h2>
        <p className="text-slate-600">Manage your trusted devices</p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Your Trusted Devices</CardTitle>
          <CardDescription>Devices that don't require OTP for login</CardDescription>
        </CardHeader>
        <CardContent>
          {loading ? (
            <div className="text-center py-8">Loading devices...</div>
          ) : devices.length === 0 ? (
            <div className="text-center py-8 text-slate-500">No trusted devices</div>
          ) : (
            <div className="overflow-x-auto">
              <Table data-testid="trusted-devices-table">
                <TableHeader>
                  <TableRow>
                    <TableHead>Device Info</TableHead>
                    <TableHead>Added</TableHead>
                    <TableHead>Actions</TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {devices.map((device) => (
                    <TableRow key={device.id} data-testid={`device-row-${device.id}`}>
                      <TableCell className="font-medium">{device.device_info}</TableCell>
                      <TableCell className="text-sm">{formatDate(device.added_at)}</TableCell>
                      <TableCell>
                        <Button
                          size="sm"
                          variant="destructive"
                          onClick={() => handleRemove(device.id)}
                          data-testid={`remove-device-${device.id}`}
                        >
                          <Trash2 className="w-4 h-4 mr-2" /> Remove
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default StaffTrustedDevices;